import { render } from "./accountProfile.vue?vue&type=template&id=a1d72f36&scoped=true"
import script from "./accountProfile.vue?vue&type=script&lang=js"
export * from "./accountProfile.vue?vue&type=script&lang=js"

import "./accountProfile.vue?vue&type=style&index=0&id=a1d72f36&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d72f36"]])

export default __exports__